module.exports = __webpack_public_path__ + "static/media/404@2x.4fb1879b.png";